import { IBusinessRostersReducer, IRoster } from 'models/Roster'
import { Action } from 'redux'
import { isType } from 'ts-action'
import { deleteFromArray, reorderArray } from 'helpers/helperFunctions'
import {
  DeleteRoster,
  GetRosters,
  RostersFetching,
  ReorderBusinessRosters,
  ClearBusinessRosters,
} from './actions'

const initialState: IBusinessRostersReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const businessRostersReducer = (
  state = initialState,
  action: Action
): IBusinessRostersReducer => {
  if (isType(action, GetRosters)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }

  if (isType(action, DeleteRoster)) {
    const { payload } = action
    const { data } = state
    const formattedArray = deleteFromArray<IRoster>(data, payload)
    return {
      ...state,
      data: formattedArray,
    }
  }

  if (isType(action, RostersFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }

  if (isType(action, ReorderBusinessRosters)) {
    const {
      payload: { oldIndex, newIndex },
    } = action
    const { data } = state
    const reorderedData = reorderArray<IRoster>(data, oldIndex, newIndex)

    return {
      ...state,
      data: reorderedData,
    }
  }

  if (isType(action, ClearBusinessRosters)) {
    return {
      ...state,
      data: [],
    }
  }

  return state
}
